var BudgetCalculator = {

    input: null,
    fundingPercentageSteps: [
        // lowerLimit, upperLimit, lowerLimitMaxFund, factor
        [0,         500000,     0,          0.49],
        [500000,    1000000,    245000,     0.31],
        [1000000,   1500000,    400000,     0.25],
        [1500000,   2500000,    525000,     0.1],
        [2500000,   10000000,   625000,     0.05]
    ],
    minBudget: 200000,
    maxFunding: 1000000,


    init: function() {
        this.calculator = jQuery('.budget-calculator');
        this.input = this.calculator.find('input');
        this.input.off('keyup').on('keyup', jQuery.proxy(this.calculate, this));
    },


    calculate: function() {
        var input = parseInt(this.input.val(), 10);
        var maxFunding = this.getMaxFunding(input);

        if (input > 0) {
            this.calculator.find('td.max-funding').html(Math.round(maxFunding) + '€');
            this.calculator.find('td.own-contribution').html(Math.round(input - maxFunding) + '€');
            this.calculator.find('td.percentage').html((parseFloat(maxFunding) / parseFloat(input) * 100.0).toFixed(1) + '%');
        } else {
            this.calculator.find('td.result').html('-');
        }
    },

    getMaxFunding: function(input) {
        var maxFunding = 0;

        if (input >= this.minBudget) {
            var step = null;
            for (var i = 0; i < this.fundingPercentageSteps.length; i++) {
                if (input > this.fundingPercentageSteps[i][0] && input <= this.fundingPercentageSteps[i][1]) {
                    step = this.fundingPercentageSteps[i];
                    break;
                }
            }
            if (step) {
                maxFunding = step[2] + (input - step[0]) * step[3];
            } else {
                maxFunding = this.maxFunding;
            }
        }

        return maxFunding;
    },

    calculatePercentageOfMaxRequested: function(total, requested) {
        return (requested/this.getMaxFunding(total));
    },

    calculateFinancialLeverageScore: function(total, requested) {
        var percentage = this.calculatePercentageOfMaxRequested(total, requested);
        var limits = [
          [0.65, 5],
          [0.75, 4],
          [0.80, 3],
          [0.85, 2],
          [1, 1]]

        if (total >= BudgetCalculator.minBudget) {
          for (var n in limits) {
            if (percentage <= limits[n][0]) {
              return limits[n][1];
            }
          }
        }

        return 0;
    }
}

window.BudgetCalculator = BudgetCalculator;